import React from 'react'

const H1Header = ({title}) => {
  return (
    <h1 className='text-4xl text-blue-100 font-bold font-Roboto'>{title}</h1>
  )
}

export default H1Header